import { styled, useTheme } from '@mui/material';
import { forwardRef, useEffect } from 'react';
import Iframe from 'react-iframe';
import { setResponsiveHeight } from '#helpers/setResponsiveHeight.ts';

export const Container = styled('div')({
  height: 0,
  position: 'relative',
  width: '100%',
});

export type FeaturePlayerProps = {
  height?: string;
  onClick?: () => void;
  responsiveHeights?: {
    lg?: string;
    md?: string;
    sm?: string;
    xl?: string;
    xs?: string;
  };
  url: string;
};

// Doesn't matter
// eslint-disable-next-line react/display-name
export const FeaturePlayer = forwardRef<HTMLDivElement, FeaturePlayerProps>(
  ({ height = '56.25%', onClick, responsiveHeights, url }, ref) => {
    const theme = useTheme();

    useEffect(() => {
      const monitor = setInterval(() => {
        const { activeElement } = document;

        if (activeElement && activeElement.tagName == 'IFRAME') {
          clearInterval(monitor);
          onClick?.();
        }
      }, 250);

      return () => {
        clearInterval(monitor);
      };
    }, [onClick]);

    return (
      <Container
        ref={ref}
        sx={{
          paddingBottom: height,
          ...(responsiveHeights ? setResponsiveHeight(theme, responsiveHeights) : undefined),
        }}
      >
        {/* @ts-expect-error react-iframe type is wrong */}
        <Iframe display="block" height="100%" position="absolute" styles={{ border: 'none' }} url={url} width="100%" />
      </Container>
    );
  },
);
